import React from "react";

const CareerHero = ({ content }) => {
  const scrollToJobs = () => {
    const element = document.getElementById("open-positions");

    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const scrollToWhyUs = () => {
    const element = document.getElementById("why-join-us");

    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <section className="career-hero">
      <div className="career-hero__background" />

      <div className="career-hero__container">
        <div className="career-hero__content">
          <span className="career-hero__eyebrow">{content.eyebrow}</span>

          <h1 className="career-hero__title">{content.title}</h1>

          <p className="career-hero__description">{content.description}</p>

          <div className="career-hero__actions">
            <button
              type="button"
              className="career-hero__button career-hero__button--primary"
              onClick={scrollToJobs}
            >
              {content.primaryButton}
              <span aria-hidden="true">→</span>
            </button>

            <button
              type="button"
              className="career-hero__button career-hero__button--secondary"
              onClick={scrollToWhyUs}
            >
              {content.secondaryButton}
            </button>
          </div>
        </div>

        <div className="career-hero__visual" aria-hidden="true">
          <div className="career-hero__orb career-hero__orb--one" />
          <div className="career-hero__orb career-hero__orb--two" />

          <div className="career-hero__panel">
            <div className="career-hero__panel-top">
              <span className="career-hero__status-dot" />
              <span>We're Building Our Team</span>
            </div>

            <div className="career-hero__panel-main">
              <span className="career-hero__panel-label">BUILD THE FUTURE</span>

              <strong>With people who care.</strong>
            </div>

            <div className="career-hero__panel-lines">
              <span />
              <span />
              <span />
            </div>
          </div>
        </div>
      </div>

      <div className="career-hero__scroll">
        <span>Scroll to explore</span>
        <span className="career-hero__scroll-line" />
      </div>
    </section>
  );
};

export default CareerHero;
